import type { ValueOf } from '../util/typeUtils';

export const DIVISION_RESOLVERS = {
    get: 'get',
    getByAggregateId: 'getByAggregateId',
    getByLeaderId: 'getByLeaderId',
    getIds: 'getIds',
    list: 'list',
} as const;

export type DIVISION_RESOLVER = ValueOf<typeof DIVISION_RESOLVERS>;
